import { render, staticRenderFns } from "./CallbackDescription.vue?vue&type=template&id=90034d8c&"
import script from "./CallbackDescription.vue?vue&type=script&lang=js&"
export * from "./CallbackDescription.vue?vue&type=script&lang=js&"
import style0 from "./CallbackDescription.vue?vue&type=style&index=0&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports